import { Injectable } from "@angular/core";

@Injectable()
export class ScrollService {

  private positions = new Map<string, number>();

  constructor(
    ) {
  }
  
  savePosition(url: string, position: number): void {
    this.positions.set(url, position);
  }

  getPosition(url: string): number | null {
    return this.positions.get(url) || null;
  }
}